/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */

import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';
import ModalContainer from 'app/components/ModalContainer';
import React, { memo, ReactNode } from 'react';
interface Props {
  open: boolean;
  message?: string | ReactNode;
  onClose: () => void;
  maskClosable?: boolean;
}

const DialogWarning = memo(
  ({ open, onClose, message, maskClosable }: Props) => {
    return (
      <ModalContainer
        isShow={open}
        onCloseDialog={onClose}
        maskClosable={maskClosable}
        CloseIcon={<CloseIcon width={12} height={12} />}
        styleSlots={{
          iconWrapperStyle: {
            margin: '-8px 0px 0px 28px',
            width: 12,
            height: 12,
          },
          modalContentStyle: {
            height: 'auto',
            width: 'auto',
            padding: '32px 30px',
            borderRadius: '16px',
          },
          modalStyle: {
            minWidth: '320px',
          },
        }}
      >
        <div style={{ textAlign: 'center' }}>
          {typeof message === 'string'
            ? (message || '')
                ?.replaceAll('\\n', '\n')
                ?.split('\n')
                ?.map(val => (
                  <div key={val}>
                    {val}
                    <br />
                  </div>
                ))
            : message}
        </div>
      </ModalContainer>
    );
  },
);

export default DialogWarning;
